
import React, { Fragment } from 'react'
import { FormTextArea , FormCheckbox, FormSubmit, FormWrapper } from '@myxplor/forms'
import withRemoteRequest from '../../remote-request'
import { withRouter } from 'react-router-dom'

const apiEndPointUnblock = (serviceId) => `${process.env.REACT_APP_API_HOST}/api/services/${serviceId}/offboard/unblock`
const apiEndPointBlock = (serviceId) => `${process.env.REACT_APP_API_HOST}/api/services/${serviceId}/offboard/block`

const unblockSubmit = ({ remote_request, serviceId, payload }) => {    
  remote_request.submit(apiEndPointUnblock(serviceId), {
    method: 'POST',
    jsonAPI: true,
    body: transformPayload(payload)
  })}

const blockSubmit = ({ remote_request, serviceId, payload }) => {    
  remote_request.submit(apiEndPointBlock(serviceId), {
    method: 'POST',
    jsonAPI: true,
    body: transformPayload(payload)
  })}

const defaultOnSubmit = ({ remote_request, serviceId }) => payload => {
  if(payload.blocked){
    blockSubmit({remote_request, serviceId, payload})
  }else{
    unblockSubmit({remote_request, serviceId, payload})
  }}

const transformPayload = (payload) => {
  return {
    notes: payload.notes
  }
}

export const PostOffboardingStatus = ({
  formOptions = {},
  remote_request,
  onSubmit = defaultOnSubmit,
  submissionBlocked,
  regHolder,
  serviceId,
  notes,
  updateNewOffboardingStatus
}) => {

  const { loading, success, data, errors } = remote_request.state
  
  if(success){
    updateNewOffboardingStatus(data)
  }

  return(
    <Fragment>
      <FormWrapper
        {...formOptions}
        defaultValues={{
          blocked: submissionBlocked,
          regHolder: regHolder,
          notes: notes
        }}
        onSubmit={onSubmit({ remote_request, serviceId })}
        render={ formProps => (
          <fieldset>
            <h2>Offboarding status - {formProps.values.regHolder.name}</h2>
            <FormCheckbox
              name='blocked'
              label='Block Submissions'
              value={formProps.values.blocked}
              onChange={formProps.onChange}
            />
            <FormTextArea
              name='notes'
              label='Notes:'
              value={formProps.values.notes}
              onChange={formProps.onChange}
              loading={ loading || !formProps.values.blocked}
              maxLength={256}
            />
            <FormSubmit
              loading={ loading }
              loadingTitle='Updating Submission Status...'
              errors={errors ? errors[0] : null}>
              Update Offboarding Status
            </FormSubmit>
          </fieldset> 
        )}   
      />  
    </Fragment>
  )
}

export default withRouter(withRemoteRequest(PostOffboardingStatus))


// WEBPACK FOOTER //
// ./src/offboarding/forms/postOffboadingStatus.js